/**
 *
 * CardLocationItem
 *
 */

import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';

import { Content, IconContainer, Label } from './CardData.styles';
import {
  Item,
  StyledPinLocationIcon,
  StyledPinLocationOutlineIcon,
} from './CardLocationItem.styles';

const VARIANTS = {
  START: 'start',
  END: 'end',
};

const CardLocationItem = ({ content, label, variant, ...props }) => {
  const icon = useMemo(() => {
    switch (variant) {
      case VARIANTS.START:
        return <StyledPinLocationOutlineIcon />;
      case VARIANTS.END:
        return <StyledPinLocationIcon />;
      default:
        return null;
    }
  }, [variant]);

  return (
    <Item disablePadding $variant={variant} {...props}>
      <IconContainer>{icon}</IconContainer>
      {content && (
        <Content>
          <Typography variant="body2" fontWeight="medium">
            {content}
          </Typography>
        </Content>
      )}
      {label && <Label>{label}</Label>}
    </Item>
  );
};

CardLocationItem.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
};

export default memo(CardLocationItem);
